import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.loadIMask()
  }

  async loadIMask() {
    try {
      const IMask = await import('imask')
      this.initializeMask(IMask.default)
    } catch (error) {
      console.error("Erro ao carregar IMask:", error)
    }
  }

  initializeMask(IMask) {
    this.maskInstance = IMask(this.element, {
      mask: '00/00/0000',
      definitions: {
        '0': {
          mask: /[0-9]/
        }
      },
      prepare: function(str) {
        return str.replace(/[^0-9]/g, '')
      },
      commit: function(value, masked) {
        // Validação básica de data
        const parts = value.split('/')
        if (parts.length === 3) {
          const day = parseInt(parts[0])
          const month = parseInt(parts[1])
          const year = parseInt(parts[2])

          if (month > 12) return ''
          if (day > 31) return ''
          if (year < 1900 || year > new Date().getFullYear()) return ''
        }
        return value
      }
    })
  }

  disconnect() {
    if (this.maskInstance) {
      this.maskInstance.destroy()
    }
  }
}
